import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import flatMap from 'lodash/flatMap'
import get from 'lodash/get'
import map from 'lodash/map'
import uniq from 'lodash/uniq'

import { LOCATION_FILTER } from 'Constants/ids'
import { useBaseTheme } from 'Hooks'
import { Dropdown } from 'Components/UI'
import { mapMarkerGlyph } from 'Assets/Svg'

import {
  ActiveStatusBadge,
  DropdownWrapper,
  Option,
  OptionIcon,
  OptionLabel,
} from './styles'

const LocationsDropdown = ({ services, onChange, fullWidth }) => {
  const { primaryColor } = useBaseTheme()
  const [selectedState, setSelectedState] = useState(null)

  const locationOptions = useMemo(() => {
    if (!services.length) {
      return []
    }

    const uniqueLocationNames = uniq(
      flatMap(services, service => map(get(service, 'locations', []), 'name')),
    )

    if (uniqueLocationNames.length <= 1) {
      return []
    }

    const locationOptionsList = uniqueLocationNames.map(name => ({
      value: name,
      label: name,
    }))

    return [
      { value: LOCATION_FILTER.ALL, label: 'All locations' },
      ...locationOptionsList,
    ]
  }, [services])

  const handleLocationStateChange = selected => {
    setSelectedState(selected)

    if (onChange) {
      onChange(selected)
    }
  }

  if (!locationOptions.length) {
    return null
  }

  const displayLabel = selectedState?.label || 'All locations'
  const hasActiveFilter =
    selectedState?.value && selectedState?.value !== LOCATION_FILTER.ALL

  return (
    <DropdownWrapper fullWidth={fullWidth}>
      <Dropdown
        activeColor={primaryColor}
        chevron
        closeOnClick
        label={
          <Option
            activecolor={primaryColor}
            as="div"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <OptionIcon glyph={mapMarkerGlyph} />
            <OptionLabel>{displayLabel}</OptionLabel>
          </Option>
        }
        options={locationOptions}
        value={selectedState?.value}
        onChange={handleLocationStateChange}
      />
      {hasActiveFilter && <ActiveStatusBadge />}
    </DropdownWrapper>
  )
}

LocationsDropdown.defaultProps = {
  services: [],
  onChange: null,
  fullWidth: false,
}

LocationsDropdown.propTypes = {
  fullWidth: PropTypes.bool,
  services: PropTypes.array,
  onChange: PropTypes.func,
}

export default LocationsDropdown
